module.exports = __webpack_public_path__ + "static/img/nav4.6d1a689e.svg";